

// order stats and params rendering
//var order;
function renderGrandParentOrder(input) {
  //order = input;

  var data = {order:input};
  $('#orderHeader').html(Handlebars.templates["orders/grandparent_order_detail_header.html"](data));
  $('#orderParameters').html(Handlebars.templates["orders/grandparent_order_detail_parameters.html"](data));
  $('#orderStats').html(Handlebars.templates["orders/grandparent_order_detail_stats.html"](data));
  //$('#orderSummary').html(Handlebars.templates["orders/client_detail_summary.html"](data));

}

class GrandParentClientOrderList extends OrderListTable {
  constructor(order, table_id) {
    super(table_id, false);
    this.order = order;
    this.setupTable();
    $(this.table_id).css('width','100%');
      }

  addOrderFilters() {
    $(this.table_id).css('width','100%');
  }
  ordering() {
    return [[ 0, "desc" ]]
  }
  _getTableAjax() {
    var self = this;
    return {url: "/api/datatables/client_orders/?format=datatables",
            data: function(d) {
              d.grandparent_order_id = self.order.client_order_id;
            }
    }
  }

  getTableColumns() {
    var columnArray = [
                { "data": "created_at", "sortable": true,
                  "render": function(data, type, row) {
                    if (type === 'sort') {
                      return data
                    }
                    if(data) {
                        return moment(data).format('llll')
                      }
                    //return moment(row.exchange_timestamp).format('llll')
                  }},

                {"data": "client_order_id"},


                { "data": "quantity", "searchable": false,
                  "render": function(data, type, row) {
                    var qty = Number(parseFloat(data).toFixed(8))
                    if (row.use_funding_currency) {
                      return `${qty} (${row.currency_pair.slug.split('-')[1]})`
                    } else {
                      return `${qty} (${row.currency_pair.slug.split('-')[0]})`

                    }
                  }},
                { "data": "executed_qty", "searchable": false,
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(8))
                    } },
                {"data": "remaining_qty",
                  "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  }
                },
                {"data": "pct_executed",
                "render": function(data, type, row) {
                  return Number(parseFloat(data).toFixed(2))
                }},

                { "data": "limit_price", "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  } },
                {"data": "order_type"},

                { "data": "avg_price", "searchable": false,
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(6))
                    }},
                { "data": "gross_consideration", "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},
                { "data": "net_consideration", "searchable": false,
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},


                { "data": "order_status_state",
                    "name": "order_status",
                    "render": function(data, type, row) {
                      if (type=="sort" || type=="filter") {
                        return row.order_status
                      }
                      return data
                    }
                  },

            ]

            return columnArray
          }

}




function setGrandParentOrderStatusColor(data) {
  var orderHeader = $('#orderStatsHeader')
  if (data.client_orders_error_ct > 0) {
    orderHeader.attr('class', 'card-header card-header-inverse card-header-danger');

  }
  else if(data.client_orders_open_ct > 0) {
    orderHeader.attr('class', 'card-header card-header-inverse card-header-success');

  } else {
    orderHeader.attr('class', 'card-header ');
  }

}

class GrandParentOrderDetailController {

  constructor(orderId, sorTableId='#sorOrders', exchangeSummaryTableId='#exchangeSummaryTable') {
    this.orderId = orderId;
    this.sorTableId=sorTableId;
    this.exchangeSummaryTableId = exchangeSummaryTableId;

    this.sorOrderTable = false;

    this.updateOrder().then((data) => {
      console.log("got data from this.updateOrder")
    });
  }

  updateOrder(force) {
    var self = this
    return this.fetchOrder().then((data) => {
      setGrandParentOrderStatusColor(data);
      renderGrandParentOrder(data);
      this.orderData = data;
      return data

    }).catch((err) =>  {
      console.log("error")
      console.log(err)
    }).then((data) => {
      if (!this.sorOrderTable) {
        this.sorOrderTable = new GrandParentClientOrderList(data, this.sorTableId);
      }
      this.sorOrderTable.refresh(force);

      if (!this.exchangeSummaryTable) {
        this.exchangeSummaryTable = new ExchangeSummaryTable(data, this.exchangeSummaryTableId)
      }
      this.exchangeSummaryTable.refresh(data);

      if (!this.feeSummaryTable) {
        this.feeSummaryTable = new FeeSummaryTable(data, "#feeSummaryTable")
      }
      this.feeSummaryTable.refresh(data);

    });
  }



  fetchOrder() {
    var self = this;
    var orderPromise = new Promise(function(resolve, reject) {

      $.ajax({
                 type: "GET",
                 url: '/api/grandparent_orders/' + self.orderId + '/',
                 success: function(data) {
                   resolve(data);

                 },
                 error: function(data)
                 {
                    throw new Error(data);
                    console.log(data);
                    console.log("error in fetch")
                 }
               });


    });
    return orderPromise
  }

  // used for submitting order reconsile changes
  update_order(pk) {
    var self = this;

    var oid_elem = $("#exchangeOrderId_" + pk)
    var oid = oid_elem.val();
    var url = '/api/sor_orders/' + pk + '/reconcile/'
    var csrftoken = $("[name=csrfmiddlewaretoken]").val();

    if (!oid) {
      var data =  {exchange_order_id: null,
                        exchange_error_ack: true}
    } else {
      var data =  {exchange_order_id: oid,
                        exchange_error_ack: true}
    }

    console.log(data);
    $.ajax({
               type: "PATCH",
               url: url,
               dataType: 'json',
               processData: false,
               data: JSON.stringify(data),
               headers: {'X-CSRFToken': csrftoken},
               contentType: 'application/json',

               success: function(data)
               {
                   console.log(data);
                   self.updateOrder(true);
               },
               error: function(data)
               {
                 console.log(data);
                 $(`#exchangeError_${pk} .small`).text(JSON.stringify(data.responseJSON));
                 $('#exchangeError_' + pk).collapse('show');
               }
             });

  }

  // used to reconsile orders flips order to editable
  updateOrderStatus(pk) {

    console.log(this);
    if (!$('#rSwitch').prop('checked')) {
      $('#rSwitch').click();
    };

    //var row = sor_orders_dt.cell( $(this).closest('td') ).row();
    var row = this.sorOrderTable.table.row('#' + pk);
    var data = row.data();
    console.log(data);
    data.exchange_error_ack=false;
    row.data(data);
    row.draw('page');
    row.scrollTo();


  }


  cancel_order(pk) {
    var url = '/api/client_orders/' + pk + '/cancel/';
    var csrftoken = $("[name=csrfmiddlewaretoken]").val();
    var self = this;
    $.ajax({
               type: "POST",
               url: url,
               data: {},
               headers: {'X-CSRFToken': csrftoken},
               success: function(data)
               {
                   self.updateOrder(true);
               },
               error: function(data)
               {
                   console.log(data);
                   console.log("error in cancel")
                   location.reload(true);
               }
             });



    }

}
